module.exports = __webpack_public_path__ + "static/media/DrivinganalysisActive.0fcd8c85.svg";